import React from 'react';
import { motion } from 'framer-motion';
import { Star, User } from 'lucide-react';
const reviews = [{
  name: 'Sandra',
  dogInfo: 'Hund: Balu, Labrador, 4 Jahre',
  avatar: 'https://images.unsplash.com/photo-1591769225440-811ad7d6eab3?w=100&h=100&fit=crop&crop=face',
  text: 'Ich war skeptisch, aber nach 2 Wochen hatte Balu zum ersten Mal wieder normalen Stuhlgang. Wir sind so erleichtert.'
}, {
  name: 'Thomas',
  dogInfo: 'Hund: Luna, Mischling, 6 Jahre',
  avatar: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=100&h=100&fit=crop&crop=face',
  text: 'Luna hatte wochenlang tagelang kein Stuhlgang und aufgeblähter Bauch. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.'
}, {
  name: 'Petra',
  dogInfo: 'Hund: Max, Golden Retriever, 3 Jahre',
  avatar: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?w=100&h=100&fit=crop&crop=face',
  text: 'Max hatte eine sehr träge Verdauung. Das Topping hat nach ca. 1 Woche gewirkt – sein Stuhl ist jetzt regelmäßig und weich. Klasse!'
}];
export function Testimonials() {
  return <section className="w-full py-16 px-4 bg-white/40" data-id="element-166">
      <div className="max-w-5xl mx-auto" data-id="element-167">
        <h2 className="font-handwriting text-4xl text-center text-forest font-bold mb-10" data-id="element-168">
          Erfahrungen anderer Hundeeltern
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-169">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card p-6 rounded-xl shadow-sm border border-brown/10 flex flex-col" data-id="element-170">
              {/* Avatar and Name */}
              <div className="flex items-center gap-3 mb-3" data-id="element-171">
                <img src={review.avatar} alt={review.name + 's Hund'} className="w-10 h-10 rounded-full object-cover flex-shrink-0" data-id="element-172" />
                <div className="flex-1 min-w-0" data-id="element-173">
                  <p className="font-serif font-bold text-gray-800" data-id="element-174">
                    {review.name}
                  </p>
                  <p className="font-serif text-xs text-gray-600 truncate" data-id="element-175">
                    ({review.dogInfo})
                  </p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4 text-yellow-500" data-id="element-176">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-177" />)}
              </div>

              {/* Review Text */}
              <p className="font-serif text-gray-700 text-sm leading-relaxed flex-grow" data-id="element-178">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}